import { FormlyFieldConfig } from '@ngx-formly/core';
import { AllegatiBolliAltroStep } from '../../shared/allegati-bolli-altro.step';
export const OccupazioneScavoStep: FormlyFieldConfig[] = [
            {
                wrappers: ['group-panel'],
                key: 'jd.elementi_scavo',
                defaultValue: [],
                type: 'repeat',
                fieldGroupClassName:
                    'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                props: {
                    addText: '+ AGGIUNGI ELEMENTO',
                    label: 'ELENCO ELEMENTI DI SCAVO',
                    required: true,
                },
                fieldArray: {
                    fieldGroup: [
                        {
                            fieldGroupClassName:
                                'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-3 gap-4',
                            fieldGroup: [
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'lunghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LUNGHEZZA (m)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'larghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LARGHEZZA (m)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'profondita',
                                    type: 'mat-input',
                                    props: {
                                        label: 'PROFONDITÀ (m)',
                                        required: true,
                                        type: 'number',
                                        min: 0.8,
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-3',
                                    key: 'pavimentazione',
                                    type: 'mat-select',
                                    props: {
                                        label: 'TIPOLOGIA PAVIMENTAZIONE',
                                        required: true,
                                        options: [
                                            {
                                                value: 1,
                                                label: 'Pavimentazione stradali in terra battuta/sterrato',
                                            },
                                            {
                                                value: 2,
                                                label: 'Pavimentazione stradale in materiale prefabbricato (massello auto-bloccante, cubetti, lastre)',
                                            },
                                            {
                                                value: 3,
                                                label: 'Pavimentazione stradale in conglomerato bituminoso o cementizio',
                                            },
                                            {
                                                value: 4,
                                                label: 'Pavimentazione di marciapiedi/piste ciclabili in conglomerato bituminoso o cementizio',
                                            },
                                            {
                                                value: 5,
                                                label: 'Ambiti a verde',
                                            },
                                            {
                                                value: 6,
                                                label: 'Pavimentazioni pedonali, lastre in materiale lapideo (pietra, porfido, arenaria etc)',
                                            },
                                            { value: 7, label: 'Scalinate' },
                                        ],
                                        change: (field) =>
                                            field.parent
                                                .get(`${field.key}_value`)
                                                .formControl.setValue(
                                                    (
                                                        field.props
                                                            .options as Array<{
                                                            value: any;
                                                            label: string;
                                                        }>
                                                    ).filter(
                                                        (x) =>
                                                            x.value ==
                                                            field.formControl
                                                                .value,
                                                    )[0].label,
                                                ),
                                    },
                                },
                                {
                                    key: 'pavimentazione_value',
                                },

                                {
                                    "className": 'sm:col-span-1 md:col-span-4',
                                    "key": 'via',
                                    type: 'mat-autocomplete',
                                    "props": {
                                        "label": 'VIA',
                                        "required": true,
                                    },
                                    "validation": {
                                        "show": true,
                                    },
                                    validators:{
                                        validation:['AutocompleteMatch'],
                                    } ,
                                    hooks: {
                                        onInit: (field) => field.props.filter = (term: string) => field.options.formState.cmp._ubicazioneService.getViaByTerm(term)
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-3',
                                    key: 'descrizione',
                                    type: 'mat-textarea',
                                    defaultValue: '',
                                    props: {
                                        label: 'DESCRIZIONE',
                                        autosize: true,
                                        autosizeMaxRows: 8,
                                        autosizeMinRows: 2,
                                    },
                                },
                            ],
                        },
                    ],
                },
            },

    {
        fieldGroup: [
            {
                wrappers: ['group-panel'],
                key: 'jd.elementi_occupazione',
                defaultValue: [],
                type: 'repeat',
                fieldGroupClassName:
                    'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                props: {
                    addText: '+ AGGIUNGI ELEMENTO',
                    label: 'ELENCO ELEMENTI DI OCCUPAZIONE SUOLO PER CANTIERE',
                    required: true,
                },
                fieldArray: {
                    fieldGroup: [
                        {
                            fieldGroupClassName:
                                'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-6 gap-4 sm:w-full',
                            fieldGroup: [
                                {
                                    className: 'sm:col-span-1 md:col-span-6',
                                    key: 'elemento',
                                    type: 'mat-select',
                                    props: {
                                        label: 'ELEMENTO DI OCCUPAZIONE',
                                        required: true,
                                        options: [
                                            {
                                                value: 1,
                                                label: 'CANTIERE MOBILE RECINTATO CON PANNELLI DI RETE PLASTIFICATA DI COLORE ARANCIONE SU PALETTI IN FERRO INFISSI NEL TERRENO',
                                            },
                                            {
                                                value: 2,
                                                label: 'CANTIERE MOBILE RECINTATO CON PANELLI DI RETE ELETTROSALDATA SU BASI DI CLS',
                                            },
                                            {
                                                value: 3,
                                                label: 'CANTIERE MOBILE RECINTATO CON CONI E/O DEFELCTOR',
                                            },
                                            {
                                                value: 8,
                                                label: 'CANTIERE MOBILE RECINTATO CON STECCATO IN LEGNO',
                                            },
                                        ],
                                        change: (field) =>
                                            field.parent
                                                .get(`${field.key}_value`)
                                                .formControl.setValue(
                                                    (
                                                        field.props
                                                            .options as Array<{
                                                            value: any;
                                                            label: string;
                                                        }>
                                                    ).filter(
                                                        (x) =>
                                                            x.value ==
                                                            field.formControl
                                                                .value,
                                                    )[0].label,
                                                ),
                                    },
                                },
                                {
                                    key: 'elemento_value',
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'tipologia',
                                    type: 'mat-select',
                                    props: {
                                        label: 'TIPO DI TARIFFA',
                                        required: true,
                                        options: [
                                            {
                                                value: 1,
                                                label: 'ATTIVITÀ LEGATA ALLO SCAVO',
                                            },
                                        ],
                                    },
                                },
                                {
                                    "className": 'sm:col-span-1 md:col-span-4',
                                    "key": 'via',
                                    type: 'mat-autocomplete',
                                    "props": {
                                        "label": 'VIA',
                                        "required": true,
                                    },
                                    "validation": {
                                        "show": true,
                                    },
                                    validators:{
                                        validation:['AutocompleteMatch'],
                                    }     ,
                                    hooks: {
                                        onInit: (field) => field.props.filter = (term: string) => field.options.formState.cmp._ubicazioneService.getViaByTerm(term)
                                    },
                                },

                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'lunghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LUNGHEZZA (m)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'larghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LARGHEZZA (m)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'altezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'ALTEZZA PONTEGGI (m)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-3',
                                    key: 'ml_giornalieri',
                                    type: 'mat-input',
                                    props: {
                                        label: ' OCCUPAZIONE GIORNALIERA (m)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-3',
                                    key: 'durata',
                                    type: 'mat-input',
                                    defaultValue:'',
                                    props: {
                                        label: 'DURATA (giorni)',
                                        description:
                                            'INDICARE LA DURATA SOLO SE SI TRATTA DI NUMERO DI GIORNI DIVERSI DA QUELLO INDICATO NELLA PRATICA',
                                        },
                                },

                                {
                                    className: 'sm:col-span-1 md:col-span-6',
                                    key: 'descrizione',
                                    type: 'mat-textarea',
                                    defaultValue: '',
                                    props: {
                                        label: 'INDICARE POSIZIONE ESATTA (UBICAZIONE DA CIVICO A CIVICO) E COSA SI OCCUPA (CARREGGIATA, STALLO DI SOSTA, AREA PEDONALE, ...)',
                                        autosize: true,
                                        required: true,
                                        autosizeMaxRows: 8,
                                        autosizeMinRows: 2,
                                },
                                },
                            ],
                        },
                    ],
                },
            },
        ],
    },
            ...AllegatiBolliAltroStep
];
